<template>
  <div>
    <hero></hero>
    <media></media>

    <downloadWallet v-if="web3 === undefined"></downloadWallet>
    <saleSummary></saleSummary>
    <tokenSummary></tokenSummary>
    <docs></docs>
    <core></core>
    <posts></posts>
    <team></team>
  </div>
</template>

<script>
import './assets/css/semantic.min.css'
import './assets/css/fonts/Maison Neue/fonts.css'

import Hero from './components/Hero'
import Media from './components/Media'
import SaleSummary from './components/SaleSummary'
import TokenSummary from './components/TokenSummary'
import Docs from './components/Docs'
import Core from './components/Core'
import Posts from './components/Posts'
import Team from './components/Team'

export default {
  name: 'app',
  components: {
    Hero,
    Media,
    SaleSummary,
    TokenSummary,
    Docs,
    Core,
    Posts,
    Team,
  },
  data() {
    return {
      web3: undefined,
      // window.web3
    }
  },
}
</script>

<style>
.aragon.sale.button {
  background-image: linear-gradient(45deg, #00b4e4 0, #00f1e1 100%) !important;
  text-transform: uppercase;
  font-weight: normal;
  color: white;
  padding: 1.25rem 3rem;
  box-shadow: 0 2px 5px rgba(0,0,0,0.5);
  transition: box-shadow 0.25s;
  border-radius: 10px;
}
.aragon.sale.button:hover,
.aragon.sale.button:active,
.aragon.sale.button:focus {
  color: white;
  box-shadow: 0 2px 10px rgba(0,0,0,1);
}
</style>



// WEBPACK FOOTER //
// App.vue?2a820cf8